import type { ReactNode } from "react";
import { styled } from "styled-components";

import type { CustomKnowledge } from "domains/customContentAndSources/types";
import { LatestViewInnerContent } from "domains/knowledgeData/components/SharedComponents";
import type { Knowledge } from "entities/knowledge/types";

const StyledKnowledgeDataItemLatestView = styled.div`
  display: flex;
  flex-direction: column;
`;

type KnowledgeDataItemLatestViewProps = {
  articleAnnouncement?: ReactNode;
  knowledge: Knowledge | CustomKnowledge;
  link: string;
  onClick: () => void;
};

export const KnowledgeDataItemLatestView = ({
  link,
  knowledge,
  onClick,
  articleAnnouncement,
}: KnowledgeDataItemLatestViewProps) => (
  <StyledKnowledgeDataItemLatestView onClick={onClick}>
    <LatestViewInnerContent knowledge={knowledge} link={link} articleAnnouncement={articleAnnouncement} />
  </StyledKnowledgeDataItemLatestView>
);
